module.exports = __webpack_public_path__ + "static/media/revision.49d86c9e.png";